// ID del Píxel de Meta de Smart Life Soluciones
export const META_PIXEL_ID = '4629261254063368'

export const PRODUCT = {
  contentName: 'El Reseteo de Sueño de 72 Horas',
  contentId: '52042020290776',
  value: 6.39,
  currency: 'USD',
}

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

let initialized = false

/** Inyecta el script del Píxel de Meta y dispara PageView una sola vez. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  if (!window.fbq) {
    const fbq: Fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as Fbq
    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    window.fbq = fbq
    window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Dispara AddToCart al hacer clic en cualquier botón de compra. */
export function trackAddToCart(): void {
  window.fbq?.('track', 'AddToCart', {
    content_name: PRODUCT.contentName,
    content_ids: [PRODUCT.contentId],
    content_type: 'product',
    value: PRODUCT.value,
    currency: PRODUCT.currency,
  })
}
